import React from "react";

export const LazyNumberInputWithErrorBridge = React.lazy(
    () =>
        import(/* webpackChunkName: "FormControls" */ "./NumberInputWithError")
);
